<template>
  <div>
    <div class="Remarks">马上预约量房</div>
    <div class="forms">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入您的姓名"></el-input>
        </el-form-item>
        <el-form-item prop="phone">
          <el-input v-model="ruleForm.phone" placeholder="请输入您的电话号码" :maxlength=11></el-input>
        </el-form-item>
         <el-form-item label prop="region">
                <VDistpicker
                  :province="ruleForm.clientprovince"
                  :city="ruleForm.clientcity"
                  :area="ruleForm.county"
                  @province="onChangeProvince"
                  @city="onChangeCity"
                  @area="onChangearea"
                ></VDistpicker>
              </el-form-item>
        <el-form-item prop="measure">
          <el-input v-model="ruleForm.measure" placeholder="请输入您的房屋面积" ></el-input>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary"  @click="toFreeRegistration">预约量房</el-button>
      </div>
    </div>
    <div class="Tips">今日已有<span class="Tipsnum">20</span>人预约设计</div>
  </div>
</template>
<script>
import VDistpicker from "v-distpicker";
export default {
  components: {
    VDistpicker,
  },
  data() {
    return {
      ruleForm: {
        name: "",
        phone:'',
        address:'',
        measure:'',
        region:'',
      },
      rules: {
        name: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          { min: 2, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ],
        phone: [
          { required: true, message: "请输入您的电话号码", trigger: "blur" },
          { min: 11, max: 11, message: "请输入正确的电话号码", trigger: "blur" }
        ],
        region: [
          { required: true, message: "请输入您的地址", trigger: "blur" },
          { min: 2, max: 19, message: "请输入正确的地址", trigger: "blur" }
        ],
        measure: [
          { required: true, message: "请输入您的房屋面积", trigger: "blur" },
          { min: 2, max: 19, message: "请输入正确的房屋面积", trigger: "blur" }
        ],
      }
    };
  },
  methods: {
    onChangeProvince(data) {
      this.ruleForm.clientprovince = data.value;
    },
    onChangeCity(data) {
      this.ruleForm.clientcity = data.value;
    },
    onChangearea(data) {
      this.ruleForm.county = data.value;
    },
    toFreeRegistration: async function(){
      let data = {
        clientcity: this.ruleForm.clientcity,
        clientname: this.ruleForm.name,
        clientprovince: this.ruleForm.clientprovince,
        county: this.ruleForm.county,
        moblephone: this.ruleForm.phone,
        source: "1",
        registertype: "6",
        remark:this.ruleForm.measure
      };
      let res = await this.exequy.appointment(data);
      //console.log('res',res);
      if (res.data.code == 0) {
        this.nubs = res.data.num;
        this.$message({
          message: "预约成功",
          type: "success"
        });
      } else {
        this.$message({
          message: "预约失败",
          type: "warning"
        });
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style scoped>
.Remarks{
  width: 100%;
  height: 3.5rem;
  line-height: 2.5rem;
}
.el-button--primary {
    color: #FFF;
    background-color: #b31d25;
    border-color: #b31d25;
    width: 80%;
}
.forms>>>.el-form-item__content {
  margin-left: 0px !important;
}
.forms >>> .distpicker-address-wrapper select:first-child {
  width: 279px;
}
.forms >>> .distpicker-address-wrapper select:not(:first-child) {
  width: 137px;
}
.el-input{
  width: 80%;
}
.forms>>>.el-form-item__error{
  position: absolute;
  left: 33px;
}
.btn{
  margin-top: 50px;
}
.Tips{
  width: 100%;
  margin-top: 30px;
}
.Tipsnum{
  color: #b31d25;
}
</style>
